export default __webpack_public_path__ + "static/media/marker_map.c12b590e.svg";